import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { selectFilter } from '../../../../store/selectors/filters'
import { HAS_SELLER_CONCESSION, IS_ASSUMABLE } from '../../../../constants/listings'
import { useState } from 'react'
import { FilterCheckBox } from '../FilterCheckBox'
import { Flex, Text } from '@homebotapp/hb-react-component-catalog'
import { selectCustomerProfile } from '../../../../store/selectors/customerProfile'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.financialFactors.heading',
    defaultMessage: 'Other Financial Factors'
  },
  hasSellerConcession: {
    id: 'HomeSearch.listings.filters.hasSellerConcession',
    defaultMessage: 'Concessions'
  },
  isAssumable: {
    id: 'HomeSearch.listings.filters.isAssumable',
    defaultMessage: 'Assumable mortgage'
  },
  financialFactorsNote: {
    id: 'HomeSearch.listings.filters.financialFactorsNote',
    defaultMessage: 'Monthly payment filter does not account for assumable mortgages'
  }
})

export const FinancialFactors = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const cp = useSelector(selectCustomerProfile)
  const [hasSellerConcession, setHasSellerConcession] = useState<boolean>(filters.hasSellerConcession === 'true')
  const [isAssumable, setIsAssumable] = useState<boolean>(`${filters.isAssumable}` === 'true')

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset>
        <Flex direction='row' gap={2} wrap={'wrap'}>
          <FilterCheckBox
            name={HAS_SELLER_CONCESSION}
            isChecked={hasSellerConcession}
            label={intl.formatMessage(MSG.hasSellerConcession)}
            onChange={e => {
              setHasSellerConcession(e.target.checked)
            }}
          />
          {cp?.assumableMortgagesEnabled && (
            <FilterCheckBox
              name={IS_ASSUMABLE}
              isChecked={isAssumable}
              label={intl.formatMessage(MSG.isAssumable)}
              onChange={e => {
                setIsAssumable(e.target.checked)
              }}
            />
          )}
        </Flex>
      </fieldset>

      {cp?.assumableMortgagesEnabled && <Text size='sm'>{intl.formatMessage(MSG.financialFactorsNote)}</Text>}
    </FilterSection>
  )
}
